var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ opacity50: _vm.disabled }},[_c('figure',{staticClass:"table-figure"},[_c('img',{staticClass:"border rounded",attrs:{"src":_vm.getImage(),"height":"50"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }